export function throttle(fn, delay) {
    let timer = null;
    return (...args) => {
        if (timer === null) {
            fn(...args);
            timer = setTimeout(() => { timer = null; }, delay);
        }
    };
}
